/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FaxesFindAllResponse } from './FaxesFindAllResponse';
import {
    FaxesFindAllResponseFromJSON,
    FaxesFindAllResponseFromJSONTyped,
    FaxesFindAllResponseToJSON,
    FaxesFindAllResponseToJSONTyped,
} from './FaxesFindAllResponse';

/**
 * 
 * @export
 * @interface FindAllFaxes200Response
 */
export interface FindAllFaxes200Response {
    /**
     * 
     */
    data?: FaxesFindAllResponse;
}

/**
 * Check if a given object implements the FindAllFaxes200Response interface.
 */
export function instanceOfFindAllFaxes200Response(value: object): value is FindAllFaxes200Response {
    return true;
}

export function FindAllFaxes200ResponseFromJSON(json: any): FindAllFaxes200Response {
    return FindAllFaxes200ResponseFromJSONTyped(json, false);
}

export function FindAllFaxes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFaxes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FaxesFindAllResponseFromJSON(json['data']),
    };
}

export function FindAllFaxes200ResponseToJSON(json: any): FindAllFaxes200Response {
    return FindAllFaxes200ResponseToJSONTyped(json, false);
}

export function FindAllFaxes200ResponseToJSONTyped(value?: FindAllFaxes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FaxesFindAllResponseToJSON(value['data']),
    };
}

